import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import percentage from "../Assets/percent.png"
import inr from "../Assets/currency.png"
import { useUser } from "../Context";
import { Link, useNavigate } from "react-router-dom";
import add from "../Assets/add.png"
import { arrayUnion, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase";
import Loading from "./Loading";
import download from "../Assets/download.png"
import * as XLSX from 'xlsx'
import refresh from "../Assets/refresh.png"
import nothing from "../Assets/nothing.png"
import graph8 from "../Assets/graph8.png"
import down from "../Assets/down.png"

export default function Dashboard() {
    const [downloadHover,setDownloadHover]=useState(false)
    const navigate = useNavigate()
    const { loading, user, setLoading, leases, setLeases } = useUser()
    const leaseListHeading = ["KEY", "Serial number", "Lessor Name", "Location", "City", "Monthly Rent", "Escalation rate", "Escalation Period", " Discount rate", "Agreement date", "Possession date", "Start date", "End date", " Security deposit", "Asset type", "Rent in", "Opening Lease Liability", "Opening ROU Asset", "Prepaid rent", "Early Termination"];
    const leaseListHeading2 = ["Serial number", "Lessor Name", "Location", "City", "Monthly Rent", "Escalation rate", "Escalation Period", " Discount rate", "Agreement date", "Possession date", "Start date", "End date", " Security deposit", "Asset type", "Rent in"];
    const leaseHeading = ["KEY", "Period", "Month", "Discount", "rent", "Payment", "RentxDisc", "opening", " monthly Interest", " closing", " pvOfSD", " ROUAss", " depreciation", " CloseROU", " interest income", " Closing PVSD"];
    // const leaseListHeading = ["Serial number", "Lessor Name", "Location", "City", "Monthly Rent", "Escalation rate", "Escalation Period", " Discount rate", "Agreement date", "Possession date", "Start date", "End date", " Security deposit", "Asset type", "Rent in","Opening Lease Liability", "Opening ROU Asset", "Prepaid rent", "Early Termination"];
    // const leaseHeading = ["Period", "Month", "Discount", "rent", "Payment", "RentxDisc", "opening", " monthly Interest", " closing", " pvOfSD", " ROUAss", " depreciation", " CloseROU", " interest income", " Closing PVSD"];

    async function fetchLeases() {
        setLoading(true)
        const tempLeaseList = []
        // console.log("inside the function",user)
        for (const leaseId of user.leaseList) {
            try {
                const leaseDoc = await getDoc(doc(db, 'lease', leaseId));
                if (leaseDoc.exists()) {
                    tempLeaseList.push({ id: leaseId, ...leaseDoc.data() })
                    // setLeaseList((prev)=>[...prev, { id: leaseId, ...leaseDoc.data() }]);
                } else {
                    console.error(`Lease document with ID ${leaseId} not found.`);
                }
            } catch (error) {
                console.error(`Error fetching lease data for ID ${leaseId}:`, error);
            }
        }
        // console.log(tempLeaseList)
        setLeases(tempLeaseList)
        setLoading(false)
    }

    async function downloadExcel() {
        setLoading(true);
        if (leases.length === 0) {
            toast.warn("No data available.")
            setLoading(false);
            return;
        }
        const workbook = XLSX.utils.book_new();
        const masterSheetData = [leaseListHeading];

        leases.forEach((lease, index) => {
            masterSheetData.push([
                user?.leaseList[index],
                index,
                lease.lesseeName,
                lease.location,
                lease.city,
                lease.rent,
                lease.escalationRate * 100,
                lease.escalationPeriod,
                lease.interest * 100,
                lease.agreeDate,
                lease.possesDate,
                lease.startDate,
                lease.endDate,
                lease.securityDeposit,
                lease.type,
                lease.paymentType,
                lease.openingLeaseLiability,
                lease.openingROUAsset,
                lease.prepaidRent,
                lease.earlyTermination
            ]);
        });

        const masterSheet = XLSX.utils.aoa_to_sheet(masterSheetData);
        XLSX.utils.book_append_sheet(workbook, masterSheet, 'Master');

        // for (let i = 0; i < leases.length; i++) {
        //     const lease = user.leaseList[i];
        //     const amortizationData = getAmortizationDataForLease(lease);
        //     const leaseSheetData = leaseHeading.map(item => [item]);

        //     amortizationData.forEach((row) => {
        //         leaseSheetData.push(row);
        //     });

        //     const leaseSheet = XLSX.utils.aoa_to_sheet(leaseSheetData);
        //     XLSX.utils.book_append_sheet(workbook, leaseSheet, `Lease ${i + 1}`);
        // }
        const promises = user?.leaseList?.map(lease => getAmortizationDataForLease(lease));
        const amortizationDataList = await Promise.all(promises);
        amortizationDataList.forEach((amortizationData, index) => {
            const leaseSheetData = [leaseHeading];

            amortizationData.forEach(row => {
                leaseSheetData.push([
                    user?.leaseList[index],
                    row.period,
                    row.month,
                    row.discountFactor,
                    row.rent,
                    row.payment,
                    row.rentIntoDisc,
                    row.openingLeaseLiability,
                    row.monthlyInterest,
                    row.closingBalance,
                    row.pvOfSD,
                    row.ROUAsset,
                    row.depreciation,
                    row.closingRou,
                    row.interestIncome,
                    row.closingPvofSD,
                ]);
            });

            const leaseSheet = XLSX.utils.aoa_to_sheet(leaseSheetData);
            XLSX.utils.book_append_sheet(workbook, leaseSheet, `Lease ${index + 1}`);
        });

        XLSX.writeFile(workbook, 'leases.xlsx');
        setLoading(false)
        setDownloadHover(!downloadHover)
    }

    async function downloadExcel2Pages() {
        setLoading(true);
        if (leases.length === 0) {
            toast.warn("No data available.");
            setLoading(false);
            return;
        }

        const workbook = XLSX.utils.book_new();

        // Create master sheet
        const masterSheetData = [leaseListHeading];
        leases.forEach((lease, index) => {
            masterSheetData.push([
                user?.leaseList[index],
                index,
                lease.lesseeName,
                lease.location,
                lease.city,
                lease.rent,
                lease.escalationRate * 100,
                lease.escalationPeriod,
                lease.interest * 100,
                lease.agreeDate,
                lease.possesDate,
                lease.startDate,
                lease.endDate,
                lease.securityDeposit,
                lease.type,
                lease.paymentType,
                lease.openingLeaseLiability,
                lease.openingROUAsset,
                lease.prepaidRent,
                lease.earlyTermination
            ]);
        });
        const masterSheet = XLSX.utils.aoa_to_sheet(masterSheetData);
        XLSX.utils.book_append_sheet(workbook, masterSheet, 'Master');

        // Create amortization sheet
        const amortizationSheetData = [];
        // const amortizationSheetHeading = [
        //     "Period",
        //     "Month",
        //     "Discount Factor",
        //     "Rent",
        //     "Payment",
        //     "Rent into Disc",
        //     "Opening Lease Liability",
        //     "Monthly Interest",
        //     "Closing Balance",
        //     "PV of SD",
        //     "ROU Asset",
        //     "Depreciation",
        //     "Closing ROU",
        //     "Interest Income",
        //     "Closing PV of SD",
        // ];
        amortizationSheetData.push(leaseHeading);

        const promises = user?.leaseList?.map(lease => getAmortizationDataForLease(lease));
        const amortizationDataList = await Promise.all(promises);
        amortizationDataList.forEach((amortizationData, index) => {
            amortizationData.forEach(row => {
                amortizationSheetData.push([
                    user?.leaseList[index],
                    row.period,
                    row.month,
                    row.discountFactor,
                    row.rent,
                    row.payment,
                    row.rentIntoDisc,
                    row.openingLeaseLiability,
                    row.monthlyInterest,
                    row.closingBalance,
                    row.pvOfSD,
                    row.ROUAsset,
                    row.depreciation,
                    row.closingRou,
                    row.interestIncome,
                    row.closingPvofSD,
                ]);
            });

            // Add an empty row as a separator between amortization schedules
            // amortizationSheetData.push([]);
        });

        const amortizationSheet = XLSX.utils.aoa_to_sheet(amortizationSheetData);
        XLSX.utils.book_append_sheet(workbook, amortizationSheet, 'Amortization');

        XLSX.writeFile(workbook, 'leases.xlsx');
        setLoading(false);
        setDownloadHover(!downloadHover)
    }


    async function getAmortizationDataForLease(lease) {
        try {
            // console.log(lease);
            const ammortizationDoc = await getDoc(doc(db, 'ammortization', lease))
            if (ammortizationDoc.exists()) {
                // console.log(ammortizationDoc.data().data)
                return ammortizationDoc.data().data
            }
        } catch (error) {
            console.log("Error in getting data");
        }

    }

    // useEffect(() => {
    //     // console.log("useEffect triggered with user:", user);
    //     if(user){
    //         if (user.leaseList?.length>0) {
    //             fetchLeases()
    //         }
    //         else{
    //             toast("Please add some data first.")
    //             navigate('/add-lease')
    //         }
    //     }
    // }, [user]);

    useEffect(() => {
        if (!loading & !user) {
            navigate('/');
        }
    }, [loading])

    return (
        <>
            {!user || loading ? <Loading /> :
                <main className="px-12 py-6">
                    {leases.length > 0 &&
                        <div className="flex items-center gap-6 px-6">
                            <Link to='/add-lease' className="shadow-sm group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white">
                                Add lease/s
                                <img className="w-5 group-hover:invert" src={add} alt="add" />
                            </Link >
                            <div className="flex flex-col items-center">
                                <button onClick={() => setDownloadHover(!downloadHover)} className="shadow-sm justify-self-end group rounded px-2 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white min-w-64">
                                    Download as excel file
                                    {downloadHover?
                                    <img className="transition-all w-5 -pt-1 group-hover:invert rotate-180" src={down} alt="add" />
                                    :
                                    <img className="transition-all w-5 pt-1 group-hover:invert" src={down} alt="add" />
                                    }
                                </button>
                                {downloadHover &&
                                    <div className="transition-all duration-200 relative h-0 w-0 gap-2 items-center flex flex-col">
                                        <button></button>
                                        <button onClick={() => downloadExcel()} className="download-button shadow-sm justify-self-end group rounded px-2 py-2 flex-shrink-0 justify-center gap-3 flex items-center border border-gray-300 hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:text-blue-500 bg-white min-w-64">
                                            Leases on separate pages
                                            {/* <img className="w-4 group-hover:filter group-hover:invert-36 group-hover:sepia-88 group-hover:saturate-891 group-hover:hue-rotate-192 group-hover:brightness-108 group-hover:contrast-93" src={download} alt="add" /> */}
                                            <img className="w-4 " src={download} alt="add" />
                                        </button>
                                        <button onClick={() => downloadExcel2Pages()} className="download-button shadow-sm justify-self-end group rounded px-2 py-2 flex-shrink-0 justify-center gap-3 flex items-center border border-gray-300 hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:text-blue-500 bg-white min-w-64">
                                            Leases on one page
                                            {/* <img className="w-4 group-hover:filter group-hover:invert-36 group-hover:sepia-88 group-hover:saturate-891 group-hover:hue-rotate-192 group-hover:brightness-108 group-hover:contrast-93" src={download} alt="add" /> */}
                                            <img className="w-4 " src={download} alt="add" />
                                        </button>
                                    </div>
                                }
                            </div>
                            <button onClick={() => { fetchLeases() }} className="shadow-sm justify-self-end group rounded px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white">
                                Refresh
                                <img className="w-4 group-hover:invert" src={refresh} alt="add" />
                            </button>
                        </div>
                    }
                    {
                        leases.length === 0 &&
                        <div className="w-screen h-[80vh] flex items-center justify-center gap-20 px-12">
                            <img className="aspect-square h-full p-16 pt-0 object-contain bg-cover bg-no-repeat" style={{ backgroundImage: `url(${graph8})` }} src={nothing} alt="character" />
                            <div className="flex flex-col gap-3">
                                <h2 className="text-[3.4rem] w-fit antialiased font-semibold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Nothing to show here.</h2>
                                {/* <h3 className="text-[2.8rem] w-fit antialiased font-semibold text-transparent bg-gradient-to-bl from-sky-500 to-indigo-500 bg-clip-text">Add lease to begin</h3> */}
                                <Link className="shadow-sm group w-fit rounded px-5 py-2.5 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-xl font-light transition-all duration-400 hover:bg-sky-500 hover:text-white" to='/add-lease'>Add Lease
                                    <img className="w-6 group-hover:invert" src={add} alt="add" />
                                </Link>
                            </div>
                        </div>
                    }
                    {/* <Link to='/add-lease' className="group px-4 py-2 w-40 justify-center gap-3 flex items-center border border-gray-300 hover:shadow-lg text-gray-900 text-lg font relative before:hover:w-full before:hover:transition-all before:duration-400 before:content-[''] before:absolute before:bg-gradient-to-tr before:from-sky-500 before:to-indigo-500 hover:text-white before:w-0 before:h-full before:left-0 before:top-0 before:-z-10">
                        Add lease/s
                        <img className="w-5 group-hover:invert" src={add} alt="add" />
                    </Link > */}
                    {leases?.length > 0 &&
                        <section className="p-6 pt-3 w-auto overflow-x-auto flex flex-col">
                            {/* {console.log(leaseList)} */}
                            {/* <h2 className="text-2xl py-4">Your lease list is: </h2> */}
                            <div className="scrollbox">
                                <div className="flex w-full justify-between">
                                    {leaseListHeading2.map((heading, index) => {
                                        return (
                                            <div className={`p-2 px-3 capitalize border min-w-48 bg-sky-500 text-white ${heading.toLocaleLowerCase() === 'location' ? "min-w-72" : ""} `} key={index}>
                                                {heading}
                                            </div>
                                        )
                                    }
                                    )
                                    }
                                </div>
                                <div className="w-full">
                                    {leases?.map((lease, index) => {
                                        return (
                                            <Link to={`/ammortization-schedule?id=${index}`} className=" flex w-auto min-w-full justify-between cursor-pointer" key={index}>
                                                <div className="min-w-48 w-auto border p-2 px-3">{index + 1}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.lesseeName}</div>
                                                <div className="min-w-72 w-auto border p-2 px-3">{lease.location}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.city}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.rent}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{(lease.escalationRate * 100).toFixed(2)}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.escalationPeriod}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{(lease.interest * 100).toFixed(2)}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.agreeDate}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.possesDate}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.startDate}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.endDate}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.securityDeposit}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.type}</div>
                                                <div className="min-w-48 w-auto border p-2 px-3">{lease.paymentType}</div>
                                            </Link>
                                        )
                                    })}
                                </div>
                            </div>
                        </section>
                    }

                </main>
            }</>
    )
}
